import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalRef } from '@freelancer/ui';

type LoginOrSignup = 'login' | 'signup';
export type ModalSource = 'pjp';

@Component({
  selector: 'app-arrow-login-signup-modal',
  template: `
    <app-arrow-login
      *ngIf="form === 'login'"
      [isModal]="true"
      [isWebappPage]="isWebappPage"
      (switchToSignup)="switchPage('signup')"
      (success)="handleSuccess()"
    ></app-arrow-login>
    <app-arrow-signup
      *ngIf="form === 'signup'"
      [isModal]="true"
      [isWebappPage]="isWebappPage"
      [modalSource]="modalSource"
      (switchToLogin)="switchPage('login')"
      (success)="handleSuccess()"
    ></app-arrow-signup>
  `,
  styleUrls: ['./arrow-login-signup-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowLoginSignupModalComponent {
  @Input() modalSource?: ModalSource;
  @Input() form: LoginOrSignup = 'login';
  @Input() isWebappPage = true;

  constructor(private modalRef: ModalRef<ArrowLoginSignupModalComponent>) {}

  switchPage(form: LoginOrSignup) {
    this.form = form;
  }

  handleSuccess() {
    this.modalRef.close();
  }
}
